// FAQ のアコーディオン制御をするクラス
export default class Faq {
  constructor () {
    this.elements = document.querySelectorAll('.accordion-faq')

    this.init()
  }

  get OPEN_CLASS () {
    return 'open'
  }

  get CLOSE_CLASS () {
    return 'close'
  }

  get TRIGGER_CLASS () {
    return 'accordion-question'
  }

  init () {
    const self = this

    this.elements.forEach(faq => {
      faq.classList.add(this.OPEN_CLASS)

      faq.querySelector('.' + this.TRIGGER_CLASS)
        .addEventListener('click', evt => {
          self.toggle(faq)
        })
    })
  }

  toggle (element) {
    if (element.classList.contains(this.OPEN_CLASS)) {
      this._hide(element)
    } else {
      this._open(element)
    }
  }

  _open (element) {
    element.classList.add(this.OPEN_CLASS)
    element.classList.remove(this.CLOSE_CLASS)
  }

  _hide (element) {
    element.classList.add(this.CLOSE_CLASS)
    element.classList.remove(this.OPEN_CLASS)
  }
}
